<template>
  <v-dialog persistent scrollable v-model="isActive" max-width="600">
    <v-card>
      <v-card-title>
        <v-flex class="font-weight-black display-1">
          {{ title }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon flat @click="dialogController.close()">
          <v-icon> fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-stepper class="elevation-0 " v-model="step">
          <v-stepper-header v-if="creation">
            <v-stepper-step
              :complete="step > 1"
              edit-icon="fas fa-check"
              editable
              step="1"
            >
              Type
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 2"
              edit-icon="fas fa-check"
              editable
              step="2"
            >
              Name
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable edit-icon="fas fa-check" step="3">
              Goal
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items class="content">
            <!-- Type -->
            <v-stepper-content :class="{ 'no-transition': !creation }" step="1">
              <v-layout wrap align-center justify-center>
                <v-flex xs12 md3>
                  <v-radio-group v-model="data.type" label="Type" class="mt-0">
                    <v-radio
                      class="mt-0"
                      color="primary"
                      label="Timer"
                      value="d"
                    ></v-radio>
                    <v-radio
                      color="primary"
                      label="Check In"
                      value="c"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md9>
                  <v-label>Example</v-label>
                  <br />
                  <br />
                  <div class="title font-weight-light">
                    {{ typeExampleText }}
                  </div>
                  <br />
                  <div>
                    {{ typeText }}
                  </div>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content :class="{ 'no-transition': !creation }" step="2">
              <v-layout column>
                <v-flex>
                  <v-layout>
                    <v-flex xs10>
                      <v-text-field
                        v-model="data.name"
                        @change="nameHandler"
                        label="Name"
                      />
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="data.index"
                        type="number"
                        @change="indexHandler"
                        max="99"
                        label="Priority"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <v-textarea
                    rows="3"
                    v-model="data.description"
                    label="Mission Statement"
                  ></v-textarea>
                </v-flex>
                <v-label>Color</v-label>
                <v-flex> <ColorEditor v-model="data.color" /> </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content :class="{ 'no-transition': !creation }" step="3">
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="items"
                    item-text="text"
                    item-value="value"
                    v-model="data.timePeriod"
                    label="Time Period"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-radio-group
                    v-model="isLessOrEqualThan"
                    label="Goal"
                    class="mt-0"
                  >
                    <v-radio
                      color="primary"
                      label="Greater or Equal"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      class="mt-0"
                      color="primary"
                      label="Less or Equal"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md6 v-if="data.type === Project.type.duration">
                  <DurationEditor v-model="durationTarget"></DurationEditor>
                </v-flex>
                <v-flex xs12 md6 v-if="data.type === Project.type.counter">
                  <v-text-field
                    @change="counterHandler"
                    label="Check In Times"
                    type="number"
                    v-model="counterTarget"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row align-center justify-center v-if="!creation">
                <v-flex shrink>
                  <v-icon large color="red" class="mr-2"
                    >fas fa-exclamation-triangle</v-icon
                  >
                </v-flex>
                <v-flex class="ml-2">
                  <v-layout column>
                    <v-flex color="red--text" class="font-weight-black">
                      Goal Will Reset
                    </v-flex>
                    <v-flex
                      >Saving will reset the start date and current
                      progress.</v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          round
          @click="onNext"
          v-if="creation && step < 3"
        >
          Next
        </v-btn>
        <v-btn
          color="primary"
          round
          @click="onSave"
          v-if="(creation && step == 3) || !creation"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ColorEditor from "@/components/ColorEditor";
import DurationEditor from "@/components/DurationEditor";
import { DialogController } from "@/classes/DialogController";
import { Project } from "@/classes/Project/Project";
export default {
  props: {
    dialogController: DialogController
  },
  components: { ColorEditor, DurationEditor },

  // TODO: Make color editor watch for this color
  data() {
    return {
      step: 1,
      data: {},
      items: [
        { text: "Day", value: Project.timePeriod.day },
        { text: "Week", value: Project.timePeriod.week },
        { text: "Month", value: Project.timePeriod.month }
      ],
      Project: Project,
      durationTarget: 0,
      counterTarget: 0
    };
  },
  computed: {
    // Set Getter
    isLessOrEqualThan: {
      get: function() {
        return this.data.operator == Project.operator.less;
      },
      set: function(val) {
        if (val) {
          this.data.operator = Project.operator.less;
        } else {
          this.data.operator = Project.operator.more;
        }
      }
    },
    // Dialog
    project() {
      return this.dialogController.data;
    },
    creation() {
      return this.dialogController.params.step == undefined;
    },
    typeText() {
      if (this.data.type == Project.type.duration) {
        return `This provides you with a timer to track how much time you have spent.`;
      } else return `This lets you record how many times you do something. `;
    },
    typeExampleText() {
      if (this.data.type == Project.type.duration) {
        return `Practice guitar at least 10 hours a week.`;
      } else return `Go to gym at least 4 times a week. `;
    },
    isActive: {
      get: function() {
        return this.dialogController.isActive;
      },
      set: function(val) {
        this.dialogController.isActive = val;
      }
    },
    title() {
      return this.creation ? "New" : "Edit";
    }
  },
  watch: {
    isActive: {
      handler: function() {
        this.step = 1;
        this.durationTarget = 0;
        this.counterTarget = 0;

        if (this.dialogController.params.step !== undefined)
          this.step = this.dialogController.params.step;
        if (this.project != undefined) {
          this.data = { ...this.project.data };
          if (this.project.isDuration()) {
            this.durationTarget = this.data.target;
          } else if (this.project.isCounter()) {
            this.counterTarget = this.data.target;
          }
        }
        if (this.data.color == "") {
          this.data.color = "#3949AB";
        }
      },
      immediate: true
    }
  },
  methods: {
    nameHandler() {
      if (
        this.data.name == undefined ||
        (this.data.name !== undefined && this.data.name.length == 0)
      ) {
        this.data.name = "Untitled";
      }
    },
    indexHandler() {
      if (Number.isNaN(parseInt(this.data.index))) {
        this.data.index = 1;
      }
      if (this.data.index < 1) this.data.index = 1;
      if (this.data.index > 99) this.data.index = 99;
    },
    counterHandler() {
      let t = parseInt(this.counterTarget);
      if (Number.isNaN(t) || t < 0) this.counterTarget = 0;
      else this.counterTarget = t;
    },
    async onSave() {
      this.data.index = parseInt(this.data.index);
      if (this.data.type == Project.type.duration) {
        this.data.target = this.durationTarget;
      } else if (this.data.type == Project.type.counter) {
        this.data.target = this.counterTarget;
      }
      this.project.updateData(this.data);
      if (this.dialogController.params.step == 3) this.project.restart();
      this.project.save();
      this.$router.push({
        name: "projectView",
        params: { projectId: this.project.projectId }
      });
      this.dialogController.close();
    },
    async onNext() {
      this.step = parseInt(this.step) + 1;
    }
  }
};
</script>

<style>
.no-transition {
  transition: none !important;
}

.content {
  min-height: 320px;
}
</style>
